import { MessageTimestamp } from '../../../../types/enums';
import type { MessageViewTableProps } from '../types';

const defaultViewProps: Partial<MessageViewTableProps> = {
  timeStampType: MessageTimestamp.LAST_POST_TIME,
  useContributors: false,
  useDraftView: false
};
export default defaultViewProps;
